import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import DateConverter from '../Tools/DateConverter';
import { ContextGloball } from '../Context/ContextGlobal';
import VerificarPermisos from '../Tools/VerificarPermisos'
import UtilsBufer from '../Tools/UtilsBufer';
const server = process.env.REACT_APP_SERVER;
function FaltantesEnvio() {
    const { loading, setLoading } = useContext(ContextGloball);
    const [regional, setRegional] = useState(JSON.parse(localStorage.getItem('info')).ID_REGIONAL_ACTUAL);
    const [sucursales, setSucursales] = useState([]);
    const [idFaltante, setIdFaltante] = useState(0);
    const [observaciones, setObservaciones] = useState('');
    const producto = [
        { 'id': -3, 'nombre': 'OCTAVO DE POLLO', 'unidad': 'Bandeja 100 oct' }, { 'id': 102, 'nombre': 'HARINADO', 'unidad': 'Bolsa' },
        { 'id': 101, 'nombre': 'REPROCESO', 'unidad': 'Bolsa' }, { 'id': 115, 'nombre': 'LLAJUA ENTERA', 'unidad': 'Bolsa' },
        { 'id': 124, 'nombre': 'LLAJUA MEDIA', 'unidad': 'Bolsa' }, { 'id': 886, 'nombre': 'SACHET SALSA GOLF', 'unidad': '50CC Sachets' },
        { 'id': 104, 'nombre': 'SACHET SALSA GOLF', 'unidad': '30CC Sachets' }, { 'id': 121, 'nombre': 'PORCION ARROZ', 'unidad': 'Porcion' },
        { 'id': 122, 'nombre': 'PORCION ARROZ+FRIJOL', 'unidad': 'Porcion' }, { 'id': 1450, 'nombre': 'PORCION ARROZ COCIDO A GRANEL', 'unidad': 'Porcion' },
        { 'id': 160, 'nombre': 'JUGO FRUTILLA TERMINADO', 'unidad': 'Bolsa 450ml' }, { 'id': 1040, 'nombre': 'JUGO FRUTILLA 450ML', 'unidad': 'Litros' },
        { 'id': 159, 'nombre': 'JUGO MANGO TERMINADO', 'unidad': 'Litros' }, { 'id': 1042, 'nombre': 'JUGO MANGO 450ML', 'unidad': 'Bolsa 450ml' },
        { 'id': 158, 'nombre': 'JUGO MARACUYA TERMINADO', 'unidad': 'Litros' }, { 'id': 1041, 'nombre': 'JUGO MARACUYA 450ML', 'unidad': 'Bolsa 450ml' }]
    function guardarInformacion() {
        setLoading(true);
        var datos = []
        for (var suc of sucursales) {
            for (var prod of producto) {
                var dato = document.getElementById(`id${suc.ID_SUCURSAL}pr${prod.id}`).value;
                if(dato!==null&&dato!=0){
                    document.getElementById(`id${suc.ID_SUCURSAL}pr${prod.id}`).className='form-control form-control-sm text-center fondoNaranjaInput  fw-bold' 
                }else{
                    document.getElementById(`id${suc.ID_SUCURSAL}pr${prod.id}`).className='form-control form-control-sm text-center bg-secondary text-light fw-bold' 
                }
                datos.push({ 'ID_SUCURSAL': suc.ID_SUCURSAL, 'ID_PRODUCTO': prod.id, 'FALTANTE': (dato == null || dato == '') ? 0 : parseInt(dato) })
            }
        }
        console.log(datos);
        var fechaa = DateConverter.getFechHoyFormaroDefault()
        var colaborador = JSON.parse(localStorage.getItem('info'))
        fetch(`${server}/supervision/addFaltanteEnvios`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, datos, sucursales, 'nuevo': idFaltante, 'fecha': fechaa, 'observaciones': observaciones, 'idEmpleado': colaborador.ID_EMPLEADO
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    MsgUtils.msgCorrecto(data.ok);
                    
                }
                setLoading(false);
            })
            .catch(error => MsgUtils.msgError(error));
    }
    function getInformacionFaltantes() {
        var fechaa = DateConverter.getFechHoyFormaroDefault()
        fetch(`${server}/supervision/getFaltanteEnvios`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, 'fecha': fechaa
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    if (data.ok.length != 0) {
                        setIdFaltante(data.ok[0].ID_INVENTARIO);
                        setObservaciones(data.ok[0].OBSERVACIONES==null?'':data.ok[0].OBSERVACIONES);
                    }
                    for (var suc of data.ok) {
                        for (var prod of suc.DETALLE) {
                            document.getElementById(`id${suc.ID_SUCURSAL}pr${prod.ID_PRODUCTO}`).value = parseInt(prod.CANTIDAD)
                            if(parseInt(prod.CANTIDAD)!==0){
                                document.getElementById(`id${suc.ID_SUCURSAL}pr${prod.ID_PRODUCTO}`).className='form-control form-control-sm text-center fondoNaranjaInput fw-bold'
                            }else{
                                document.getElementById(`id${suc.ID_SUCURSAL}pr${prod.ID_PRODUCTO}`).className='form-control form-control-sm text-center bg-secondary text-light fw-bold'                                
                            }
                        }
                    }
                }
            })
            .catch(error => MsgUtils.msgError(error));
    }
    useEffect(() => {
        setLoading(true);
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    MsgUtils.msgError(data.error);
                    setLoading(false)
                } else {
                    getInformacionFaltantes();
                    console.log(data.ok)
                    setSucursales(data.ok);
                }

            })
            .catch(error => MsgUtils.msgError(error));
    }, [])
    return (
        <div>
            <div className='bg-dark bg-gradient py-1'>
                <div className='btn-group btn-group-sm'>
                    <div className='text-light fw-bold'>
                        {`Registro Faltante del ${DateConverter.formatoFechaYMD(new Date())}`}
                    </div>
                    {VerificarPermisos.validarPermiso('45') && <button className='btn btn-success bg-gradient btn-sm mx-2' onClick={() => guardarInformacion()}>
                        <i className="fa-solid fa-floppy-disk"></i>
                        Guardar
                    </button>}
                </div>
            </div>
            <div className='table-responsive'>
                <table className="table table-sm table-dark table-stripet table-bordered border-light">
                    <thead>
                        <tr className='text-center'>
                            <th >ID</th>
                            <th >PRODUCTO</th>
                            <th >UNIDAD</th>
                            {sucursales.map((item, index) => {
                                return (<th key={index}>{item.SUCURSAL}</th>)
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {producto.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <th scope="row">{item.id}</th>
                                    <td style={{ minWidth: '240px' }}>{item.nombre}</td>
                                    <td>{item.unidad}</td>
                                    {sucursales.map((suc, indexx) => {
                                        return (<td key={indexx} style={{ minWidth: '80px' }}>
                                            <input type="number" className="form-control form-control-sm text-center bg-secondary text-light fw-bold"
                                                disabled={VerificarPermisos.validarPermiso('45') ? false : true}
                                                id={`id${suc.ID_SUCURSAL}pr${item.id}`} />
                                        </td>)
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <div className='container-fluid'>
                <div className="form-floating">
                    <textarea className="form-control" placeholder="Escriba Aqui"
                        style={{ height: '100px' }} value={observaciones}
                        onChange={(e) => {
                            if(observaciones.length<150){
                                setObservaciones(e.target.value)
                            }
                            }}></textarea>
                    <label >Observaciones</label>
                </div>
            </div>
        </div>
    )
}

export default FaltantesEnvio